import { makeStyles } from '@material-ui/core/styles'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'

const useStyles = makeStyles(theme => ({
  mainContent: pageContentHorizontalGutters(theme, {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    width: 'auto',
    sm: {
      paddingTop: theme.spacing(2),
      marginTop: 10,
      marginBottom: theme.spacing(4),
    },
  }),
  container: pageContentHorizontalGutters(theme, {
    paddingTop: 0,
    margin: '0 0 60px',
    width: 'auto',
    sm: {
      paddingTop: 0,
      margin: '0 0 60px',
    },
  }),
}))

export default useStyles
